module.exports = "pegasus/assets/themelp1/ebook/108.png";